import { z } from "zod";

/** Términos clave extraídos de documentación de financiación (Gemini). */
export const financingKeyTermSchema = z.object({
  label: z.string(),
  value: z.string(),
});

export const financingSummaryPayloadSchema = z.object({
  summaryBullets: z.array(z.string()).optional(),
  keyTerms: z.array(financingKeyTermSchema).optional(),
  suggestedInstallmentMinor: z.number().int().nullable().optional(),
  suggestedCurrency: z
    .string()
    .length(3)
    .regex(/^[A-Z]{3}$/)
    .nullable()
    .optional(),
  suggestedContractStartOn: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .nullable()
    .optional(),
  suggestedEndsOn: z
    .string()
    .regex(/^\d{4}-\d{2}-\d{2}$/)
    .nullable()
    .optional(),
  warnings: z.array(z.string()).optional(),
  confidence: z.number().min(0).max(1).nullable().optional(),
});

export type FinancingKeyTerm = z.infer<typeof financingKeyTermSchema>;
export type FinancingSummaryPayload = z.infer<typeof financingSummaryPayloadSchema>;

export function parseFinancingSummaryPayload(raw: unknown): FinancingSummaryPayload | null {
  const parsed = financingSummaryPayloadSchema.safeParse(raw);
  return parsed.success ? parsed.data : null;
}
